import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useLang } from "../../i18n";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

const texts = {
  it: {
    title: "Privacy Policy",
    updated: "Ultimo aggiornamento: 11 Ottobre 2026",
    intro: 'La presente informativa descrive come Kashmira&Co (titolare del trattamento) tratta i dati personali inviati tramite questo sito, in attuazione del Regolamento UE 2016/679 ("GDPR").',
    s1: "Titolare del trattamento",
    p1: "Kashmiracompany — P.IVA 01588410082 — Prato (Firenze), 50100 — Email: kashmiracompany96@gmail.com — Tel: 351 586 5985.",
    s2: "Quali dati raccogliamo",
    p2: "Attraverso il modulo contatti raccogliamo: nome e cognome, azienda (facoltativa), tipo di attività, indirizzo email, numero di telefono (facoltativo) e il contenuto del messaggio. Attraverso la newsletter raccogliamo l'indirizzo email. Non raccogliamo altri dati né utilizziamo strumenti di tracciamento.",
    s3: "Finalità e base giuridica",
    p3: "I dati sono trattati per rispondere alle tue richieste di informazioni commerciali (base giuridica: esecuzione di misure precontrattuali, art. 6 lett. b GDPR). Solo con il tuo consenso esplicito utilizziamo email e telefono per inviarti novità e offerte (base giuridica: consenso, art. 6 lett. a GDPR).",
    s4: "Conservazione dei dati",
    p4: "I dati relativi alle richieste sono conservati per il tempo necessario a gestirle e, in ogni caso, non oltre 12 mesi. I dati trattati con finalità di marketing sono conservati fino alla revoca del consenso.",
    s5: "Diritti dell'interessato",
    p5: "Puoi esercitare in ogni momento i diritti di accesso, rettifica, cancellazione, limitazione, portabilità e opposizione scrivendo a kashmiracompany96@gmail.com. Hai inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
    s6: "Modifiche",
    p6: "La presente informativa può essere modificata in qualsiasi momento: ti invitiamo a consultare periodicamente questa pagina.",
  },
  en: {
    title: "Privacy Policy",
    updated: "Last updated: 11 October 2026",
    intro: 'This notice describes how Kashmira&Co (the data controller) processes the personal data submitted through this website, pursuant to EU Regulation 2016/679 ("GDPR").',
    s1: "Data controller",
    p1: "Kashmiracompany — VAT 01588410082 — Prato (Florence), 50100 — Email: kashmiracompany96@gmail.com — Tel: 351 586 5985.",
    s2: "What data we collect",
    p2: "Through the contact form we collect: full name, company (optional), business type, email address, phone number (optional) and the message content. Through the newsletter we collect your email address. We collect no other data and use no tracking tools.",
    s3: "Purpose and legal basis",
    p3: "Data is processed to answer your commercial enquiries (legal basis: performance of pre-contractual measures, Art. 6(1)(b) GDPR). Only with your explicit consent do we use email and phone to send you news and offers (legal basis: consent, Art. 6(1)(a) GDPR).",
    s4: "Data retention",
    p4: "Request data is kept for the time needed to handle it and, in any case, no longer than 12 months. Marketing data is kept until consent is withdrawn.",
    s5: "Your rights",
    p5: "You may exercise your rights of access, rectification, erasure, restriction, portability and objection at any time by writing to kashmiracompany96@gmail.com. You may also lodge a complaint with the Italian Data Protection Authority (www.garanteprivacy.it).",
    s6: "Changes",
    p6: "This notice may change at any time: please check this page periodically.",
  },
  fr: {
    title: "Politique de confidentialité",
    updated: "Dernière mise à jour : 11 octobre 2026",
    intro: "La présente information décrit comment Kashmira&Co (responsable du traitement) traite les données personnelles envoyées via ce site, conformément au Règlement UE 2016/679 (« RGPD »).",
    s1: "Responsable du traitement",
    p1: "Kashmiracompany — N° TVA 01588410082 — Prato (Florence), 50100 — Email : kashmiracompany96@gmail.com — Tél : 351 586 5985.",
    s2: "Quelles données collectons-nous",
    p2: "Via le formulaire de contact, nous collectons : nom et prénom, entreprise (facultatif), type d'activité, adresse email, téléphone (facultatif) et le contenu du message. Via la newsletter, nous collectons votre adresse email. Aucune autre donnée n'est collectée et aucun outil de traçage n'est utilisé.",
    s3: "Finalités et base légale",
    p3: "Les données sont traitées pour répondre à vos demandes d'informations commerciales (base légale : mesures précontractuelles, art. 6 let. b RGPD). Ce n'est qu'avec votre consentement explicite que nous utilisons email et téléphone pour vous envoyer actualités et offres (base légale : consentement, art. 6 let. a RGPD).",
    s4: "Conservation des données",
    p4: "Les données des demandes sont conservées le temps nécessaire et, en tout état de cause, 12 mois au maximum. Les données marketing sont conservées jusqu'au retrait du consentement.",
    s5: "Vos droits",
    p5: "Vous pouvez exercer à tout moment vos droits d'accès, de rectification, d'effacement, de limitation, de portabilité et d'opposition en écrivant à kashmiracompany96@gmail.com. Vous pouvez également déposer une réclamation auprès du Garante pour la protection des données personnelles (www.garanteprivacy.it).",
    s6: "Modifications",
    p6: "La présente information peut être modifiée à tout moment : consultez régulièrement cette page.",
  },
};

const Shell = ({ title, testId, children }) => (
  <div data-testid={testId} className="min-h-screen bg-[#FBF9F5] pt-36 pb-24">
    <div className="max-w-3xl mx-auto px-6">
      <Link to="/" data-testid={`${testId}-back`} className="font-mono text-xs uppercase tracking-[0.2em] text-[#9A4930] link-underline">← Torna al sito</Link>
      <h1 className="mt-8 font-serif font-light text-5xl lg:text-6xl tracking-tight text-[#1C1917]">{title}</h1>
      <div className="mt-14 space-y-10 text-[#57534E] leading-relaxed">{children}</div>
    </div>
  </div>
);

const H = ({ children }) => <h2 className="font-serif text-2xl lg:text-3xl text-[#1C1917] pt-4">{children}</h2>;

export const PrivacyPolicy = () => {
  const { lang } = useLang();
  const x = texts[lang] || texts.it;
  return (
    <Shell title={x.title} testId="legal-page-privacy">
      <p>{x.intro}</p>
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#57534E]">{x.updated}</p>
      <div><H>{x.s1}</H><p className="mt-4">{x.p1}</p></div>
      <div><H>{x.s2}</H><p className="mt-4">{x.p2}</p></div>
      <div><H>{x.s3}</H><p className="mt-4">{x.p3}</p></div>
      <div><H>{x.s4}</H><p className="mt-4">{x.p4}</p></div>
      <div><H>{x.s5}</H><p className="mt-4">{x.p5}</p></div>
      <div><H>{x.s6}</H><p className="mt-4">{x.p6}</p></div>
    </Shell>
  );
};

const cookie = {
  it: {
    title: "Cookie Policy",
    intro: "Questa politica spiega come vengono utilizzati i cookie e gli strumenti di archiviazione simili sul sito Kashmiracompany.",
    s1: "Cosa sono i cookie",
    p1: "I cookie sono piccoli file di testo che i siti visitati inviano al browser dell'utente e che vengono salvati e ritrasmessi alle visite successive.",
    s2: "Cookie utilizzati da questo sito",
    p2: "Questo sito non utilizza cookie di profilazione o tracciamento di alcun tipo, né propri né di terze parti. L'unica memorizzazione tecnica presente è il token di accesso all'area riservata interna, conservato nella sessione del browser e cancellato alla chiusura della scheda: non serve a tracciarti né a profilarti.",
    s3: "Gestione delle preferenze",
    p3: 'Puoi cancellare o bloccare i dati di archiviazione in qualsiasi momento dalle impostazioni del tuo browser (sezione "Privacy e sicurezza"). Il blocco non compromette la navigazione del sito pubblico.',
    s4: "Modifiche",
    p4: "Questa politica può essere aggiornata in qualsiasi momento: verifica periodicamente questa pagina.",
  },
  en: {
    title: "Cookie Policy",
    intro: "This policy explains how cookies and similar storage tools are used on the Kashmiracompany website.",
    s1: "What are cookies",
    p1: "Cookies are small text files that visited websites send to the user's browser, saved and retransmitted on subsequent visits.",
    s2: "Cookies used on this website",
    p2: "This website uses no profiling or tracking cookies of any kind, neither its own nor third-party ones. The only technical storage is the access token for the internal reserved area, kept in the browser session and deleted when the tab is closed: it is not used to track or profile you.",
    s3: "Managing preferences",
    p3: 'You can delete or block storage data at any time from your browser settings ("Privacy and security" section). Blocking it does not affect browsing the public site.',
    s4: "Changes",
    p4: "This policy may be updated at any time: please check this page periodically.",
  },
  fr: {
    title: "Politique de cookies",
    intro: "Cette politique explique comment les cookies et outils de stockage similaires sont utilisés sur le site Kashmiracompany.",
    s1: "Qu'est-ce qu'un cookie",
    p1: "Les cookies sont de petits fichiers texte que les sites visités envoient au navigateur de l'utilisateur, sauvegardés et retransmis lors des visites suivantes.",
    s2: "Cookies utilisés sur ce site",
    p2: "Ce site n'utilise aucun cookie de profilage ou de traçage, ni les siens ni ceux de tiers. La seule sauvegarde technique est le jeton d'accès à l'espace réservé interne, conservé dans la session du navigateur et supprimé à la fermeture de l'onglet : il ne sert ni à vous tracer ni à vous profiler.",
    s3: "Gestion des préférences",
    p3: "Vous pouvez supprimer ou bloquer les données de stockage à tout moment depuis les réglages de votre navigateur (section « Confidentialité et sécurité »). Le blocage n'empêche pas la navigation sur le site public.",
    s4: "Modifications",
    p4: "Cette politique peut être mise à jour à tout moment : consultez régulièrement cette page.",
  },
};

export const CookiePolicy = () => {
  const { lang } = useLang();
  const x = cookie[lang] || cookie.it;
  return (
    <Shell title={x.title} testId="legal-page-cookie">
      <p>{x.intro}</p>
      <div><H>{x.s1}</H><p className="mt-4">{x.p1}</p></div>
      <div><H>{x.s2}</H><p className="mt-4" dangerouslySetInnerHTML={{ __html: x.p2 }} /></div>
      <div><H>{x.s3}</H><p className="mt-4" dangerouslySetInnerHTML={{ __html: x.p3 }} /></div>
      <div><H>{x.s4}</H><p className="mt-4">{x.p4}</p></div>
    </Shell>
  );
};
